/* ============================================================
   OS JV – Sticky Header Timer (shared)
   - Persists across pages via localStorage end timestamp
   - Uses one shared key so Quantity -> Flavors continues
   ============================================================ */

(function () {
  const DEFAULT_KEY = 'osjv_jv_timer_end_v1';

  function pad2(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function getNowMs() {
    return Date.now();
  }

  function initOneTimer(el) {
    const durationSeconds = parseInt(el.getAttribute('data-duration-seconds') || '10800', 10); // default 3 hours
    const storageKey = (el.getAttribute('data-storage-key') || DEFAULT_KEY).trim();

    const textNode = el.querySelector('[data-osjv-timer-text]');
    const hhNode = el.querySelector('[data-osjv-hh]');
    const mmNode = el.querySelector('[data-osjv-mm]');
    const ssNode = el.querySelector('[data-osjv-ss]');

    // Read existing end time; if missing/invalid/expired => create a new one
    const now = getNowMs();
    const raw = localStorage.getItem(storageKey);
    let endMs = raw ? parseInt(raw, 10) : NaN;

    if (!Number.isFinite(endMs) || endMs <= now) {
      endMs = now + (durationSeconds * 1000);
      try { localStorage.setItem(storageKey, String(endMs)); } catch (e) {}
    }

    // Render loop
    function tick() {
      const now2 = getNowMs();
      let remain = Math.floor((endMs - now2) / 1000);

      if (!Number.isFinite(remain)) remain = 0;
      if (remain < 0) remain = 0;

      const hh = Math.floor(remain / 3600);
      const mm = Math.floor((remain % 3600) / 60);
      const ss = remain % 60;

      if (hhNode) hhNode.textContent = pad2(hh);
      if (mmNode) mmNode.textContent = pad2(mm);
      if (ssNode) ssNode.textContent = pad2(ss);

      // If hit zero, stop ticking (keeps 00:00:00). Next full reload will reset.
      if (remain <= 0) return;

      // Align close to real seconds without drifting
      const nextInMs = 250;
      setTimeout(tick, nextInMs);
    }

    // Optional: allow live text updates via dataset (if you ever change it in Liquid)
    if (textNode) {
      const txt = el.getAttribute('data-banner-text');
      if (txt) textNode.textContent = txt;
    }

    tick();
  }

  function initAll() {
    const els = document.querySelectorAll('[data-osjv-sticky-timer]');
    if (!els.length) return;
    els.forEach(initOneTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
